import { CommonModule } from '@angular/common';
import { Component, computed, inject, ChangeDetectionStrategy } from '@angular/core';
import { AcceleratorAreaService } from '../../../accelerator-area.service';


@Component({
	selector: 'acc-delivery-awards-tab-part',
	standalone: true,
	imports: [CommonModule],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './acc-delivery-awards-tab.part.html',
})
export class AccDeliveryAwardsTabPart {

	private readonly accAreaService = inject(AcceleratorAreaService);

	public awardsInfo = computed(() => {
		const data = this.accAreaService.data();
		if (!data) return undefined;

		return {
			totalBudget: data.acc.awardableDollars,
			moneyAwarded: data.awards.reduce((sum, award) => sum + award.value, 0),
		}
	});
}
